import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";

const styles = (theme) => ({
  radioRoot: {
    padding: "5px 12px",
    color: theme.gridTextColor,
  },
  formLabel: {
    fontSize: theme.textFontSize,
    padding: "5px 0px",
    color: theme.gridTextColor,
  },
  formControlLabel: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    color: theme.gridTextColor,
  },
  formControlLabelFilled: {
    color: theme.HeaderSelectedText,
  },
  formControlLabelRootFilled: {
    backgroundColor: theme.radioLabel,
    padding:"4px 12px",
    borderRadius: 32,
    marginLeft:0
  },
  radioRootFilled: {
    padding:"0px 4px 0px 0px",
  },
});

class CustomRadioGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue,
    };
  }

  handleRadioChange = (event) => {
    this.setState({
      value: event.target.value,
    });
    this.props.onChange?.(event.target.value);
  };

  getFilledClasses = () => {
    if (this.props.variant === "filled") {
      return {
        formLabel: this.props.classes.formControlLabelFilled,
        radioRoot: this.props.classes.radioRootFilled,
        labelRoot: this.props.classes.formControlLabelRootFilled,
      };
    }
    return {
      formLabel: "",
      radioRoot: "",
      labelRoot: "",
    };
  };

  render() {
    const { classes, labels, customClass=null } = this.props;
    const filledClasses = this.getFilledClasses();
    return (
      <RadioGroup
        row
        onChange={this.handleRadioChange}
        value={this.state.value}
        className = {customClass}
      >
        {labels.map((labelObj) => (
          <FormControlLabel
            classes={{
              label: `${classes.formControlLabel} ${filledClasses.formLabel}`,
              root: filledClasses.labelRoot,
            }}
            key={labelObj.value}
            value={labelObj.value}
            disabled={labelObj.disabled}
            control={
              <Radio
                color="primary"
                classes={{
                  root: `${classes.radioRoot} ${filledClasses.radioRoot}`,
                }}
                disabled={labelObj.disabled}
              />
            }
            label={labelObj.labelText}
          />
        ))}
      </RadioGroup>
    );
  }
}

export default withStyles(styles)(CustomRadioGroup);
